/**
 * Hardcoding user for MVP
 * TODO(Implement auth)
 */

export const user = {
  id: '62a29c15f4605c4c9fa7f306',
}
